import React from "react";

import RedoIcon from "../../../Layout/Icons/RedoIcon";

const Redo = ({ onRedo, canRedo }) => {
  return (
    <div className="control__container">
      <button
        className="control__button button button--canvas button--redo"
        onClick={onRedo}
        disabled={!canRedo}
      >
        <RedoIcon />
      </button>
      <div className="control__title">Redo</div>
    </div>
  );
};

export default Redo;
